import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';

import Swal from 'sweetalert2';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { TeemappTableComponent } from '@teem/shared-component/teemapp-table/teemapp-table.component';
import { ACTIONS as USER_ACTIONS } from '@teem/constants/users';
import { SharedDataService } from '@teem/services/shared-data.service';
import { UserService } from '@teem/services/user.service';
import { UserCurrencyPipe } from '@teem/pipes/user-currency.pipe';
import { LoaderService } from '@teem/services/loader.service';
import { ngDebounce } from '@teem/decorators/debouce.decorator';
import { environment } from '@teem/environments/environment';
import { messages as i18n } from '@teem/constants/messages';
import { PLAN_TYPES } from '@teem/constants/subscription';
import { User } from '@teem/models/user';

import UsersTableSchema from '@teem/users-module/classes/users-table-schema';
import { AddUserModalComponent } from '@teem/users-module/modals/add-user-modal/add-user-modal.component';
import { EditUserModalComponent } from '@teem/users-module/modals/edit-user-modal/edit-user-modal.component';

declare var $;

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styles: [],
  providers: [UserCurrencyPipe]
})
export class UsersComponent implements OnInit {
  @ViewChild('searchInput') searchInput: any;
  @ViewChild('usersTableRef') usersTableRef: TeemappTableComponent;
  @ViewChild('draftsTableRef') draftsTableRef: TeemappTableComponent;

  activeTab: string = 'all-users';
  previousTab: string = 'all-users';
  isSearch: boolean = false;
  routeSubscriber: any;
  userInfo: any;
  userDetails: any = null;

  // Users table variables
  usersTable: UsersTableSchema = new UsersTableSchema(this);
  usersMenuItems: Array<any> = [    
    // { key: "view_user", label: $localize`:@@ts.print_users:View User`, onClick: this.viewUser.bind(this), singleOnly: true },  
    // { key: "delete_users", label: $localize`:@@ts.delete_users:Delete Users`, onClick: this.deleteUsers.bind(this) },
  ];

  constructor(
    private loaderService: LoaderService,
    private userService: UserService,
    private route: ActivatedRoute,
    private currencyPipe: UserCurrencyPipe,
    private router: Router,
    private modalService: NgbModal,
    private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    // Show/Hide whatsapp action as per pro plan
    this.sharedDataService.asObservable().subscribe((data) => {
      if (data && data.userInfo) {
        this.userInfo = data.userInfo;
      }
    })
  }

  userActions(action, user: any) {
    switch (action) {
      case 'delete':
        this.deleteUsers([user.uuid])
        break;
      case 'edit':
        this.editExpenses([user.uuid])
        break;
    }
  }

  isProPlan() {
    return this.userInfo && this.userInfo.subscription && this.userInfo.subscription.subscription_plan == PLAN_TYPES.pro;
  }

  editExpenses(uuid) {
    this.loaderService.startLoading();
    this.userService.getTeemUser(uuid).subscribe(userDetails => {
      this.userDetails = userDetails;
      this.openEditUserModal();
      this.loaderService.stopLoading();
    }, err => {
      this.loaderService.stopLoading();
    })
  }

  openEditUserModal() {
    let modalRef = this.modalService.open(EditUserModalComponent);
    modalRef.componentInstance.userDetails = this.userDetails;
    modalRef.componentInstance.isProPlan = this.isProPlan;
    modalRef.componentInstance.el.nativeElement.parentNode.parentNode.id = "newClient";

    modalRef.result.then(result => {
      this.usersTableRef.getPage(1);
    }, fallbackResult => {
      // do nothing
    })
  }

  // onUserEdit(selected: Array<string>) {
  //   if (selected.length === 1) {
  //     this.loaderService.startLoading();
  //     this.userService.get(selected[0]).subscribe((quotation: Quotation) => {

  //       const modalRef = this.modalService.open(EditUserModalComponent);
  //       modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.id = "newClient";
  //       modalRef.result.then(result => {
  //         // this.usersTableRef.getPage(1);
  //         this.loaderService.stopLoading();
  //       }, fallbackResult => {
  //         // do nothing
  //       })
        
  //       // this.activeQuotation = quotation;
  //       // this.activeTab = "edit-quote";
  //       // this.loaderService.stopLoading();
  //     }, err => {
  //       Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
  //       this.loaderService.stopLoading();
  //     })
  //   }
  // }

  openAddClientModal() {
    const modalRef = this.modalService.open(AddUserModalComponent);
    modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.id = "newClient";
    modalRef.result.then(result => {
      this.usersTableRef.getPage(1);
    }, fallbackResult => {
      // do nothing
    })
  }

  goToPreviousTab() {
    if (this.previousTab) {
      this.activeTab = this.previousTab;
    } else {
      this.activeTab = "all-users";
    }

    if (this.route.snapshot.queryParams['create-user']) {
      this.router.navigateByUrl('users');
    }
  }

  searchUsers(term: string) {
    if (this.activeTab == 'all-users') {
      this.usersTableRef.search.next(term);
    } else if (this.activeTab == 'drafts') {
      this.draftsTableRef.search.next(term);
    }
  }

  toggleSearch() {
    this.isSearch = !this.isSearch;

    if (this.isSearch) {
      this.searchInput.nativeElement.focus();
    } else {
      this.searchInput.nativeElement.value = "";
      this.searchUsers("");
    }
  }

  deleteUsers(selected: Array<string>) {
    if (selected.length) {
      Swal.fire({
        title: i18n.are_you_sure,
        text: i18n.user.you_want_to_delete_user,
        icon: 'info',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText:
          i18n.yes,
        cancelButtonText:
          i18n.no_cancel_it
      }).then(result => {
        if (result.value) {
          this.loaderService.startLoading();
          this.userService.action({ 'do': USER_ACTIONS.DELETE, 'ids': selected }).subscribe(data => {
            this.loaderService.stopLoading();
            this.activeTab = 'all-users';
            this.usersTableRef.getPage(1);
            Swal.fire(i18n.deleted, selected.length == 1 ? i18n.user.user_deleted : i18n.user.users_deleted, 'success');
          }, err => {
            this.loaderService.stopLoading();
            Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
          });
        }
      });
    }
  }

  exportXls() {
    (window as any).open(`${environment.baseUrl}/users/download`, '_self', 'location=yes');
  }

}
